<template>
    <div class="c-ty" :style="wrapStyle">
        <div :style="innerStyle">
            <CornerOrnament v-if="!isMobile" corner="tr" :size="180" :opacity="0.3" />
            <CornerOrnament v-if="!isMobile" corner="bl" :size="180" :opacity="0.3" />

            <div :style="cardWrapStyle">
                <div :style="checkStyle">✓</div>
                <div :style="eyebrowStyle">Submitted</div>
                <h1 :style="h1Style">Beautifully done.</h1>
                <p :style="leadStyle">
                    TAG has received your submission. We'll reconcile and reach out
                    about commission.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { scrollToTop } from "../../../helpers/_scrollToTop";

import CornerOrnament from "../c-design/CornerOrnament.vue";
import viewportMixin from "../c-design/useViewport";
import {
    C_BG,
    C_INK,
    C_MUTED,
    C_GREEN,
    FONT_DISPLAY,
} from "../c-design/tokens";

/**
 * Stage 9 of the wizard redesign. The final "thank-you" screen the
 * wizard lands on after FinalDashboard's "Submit {month}" CTA.
 * Mirrors the prototype's DoneC visual: centered green check, eyebrow,
 * Inter Tight headline, lead text, with the same geometric corner
 * ornaments that frame the LoginC card.
 */
export default {
    name: "Wizard_Thank_You",
    mixins: [viewportMixin],
    components: { CornerOrnament },
    methods: {},

    mounted() {
        scrollToTop();
    },
    computed: {
        wrapStyle() {
            return {
                background: C_BG,
                minHeight: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: this.isMobile ? '20px 16px' : '32px',
                position: 'relative',
            };
        },
        innerStyle() {
            return {
                position: 'relative',
                width: '100%',
                maxWidth: '560px',
            };
        },
        cardWrapStyle() {
            return {
                position: 'relative',
                zIndex: 1,
                textAlign: 'center',
                padding: '40px 32px',
            };
        },
        checkStyle() {
            return {
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                background: C_GREEN,
                color: '#fff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '36px',
                fontWeight: 700,
                marginBottom: '20px',
            };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px',
                color: C_GREEN,
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                fontWeight: 700,
                marginBottom: '8px',
            };
        },
        h1Style() {
            return {
                margin: '0 0 12px',
                fontFamily: FONT_DISPLAY,
                fontSize: this.isMobile ? '30px' : '40px',
                fontWeight: 700,
                letterSpacing: this.isMobile ? '-0.9px' : '-1.2px',
                lineHeight: 1.1,
                color: C_INK,
            };
        },
        leadStyle() {
            return {
                margin: 0,
                fontSize: '15px',
                color: C_MUTED,
                lineHeight: 1.55,
            };
        },
    },
};
</script>
